// extracted by mini-css-extract-plugin
export default {"cardRow":"cardRow_cardRow__HeyqC","cardRowBorder":"cardRow_cardRowBorder__UQD0K","cardRowTransparent":"cardRow_cardRowTransparent__C4dDZ"};